import { create } from 'zustand';

type HoverCardState = {
  anchorEl: HTMLElement | null;
  optionId: string | null;
  setCard: (anchorEl: HTMLElement | null, optionId: string | null) => void;
  clear: () => void;
  clearOptionId: () => void;
  scheduleClear: (delay?: number) => void;
  cancelClear: () => void;
};

let _closeTimer: ReturnType<typeof setTimeout> | null = null;

export const useHoverCardStore = create<HoverCardState>((set) => ({
  anchorEl: null,
  optionId: null,
  setCard: (anchorEl, optionId) => {
    if (_closeTimer) {
      clearTimeout(_closeTimer);
      _closeTimer = null;
    }
    set({ anchorEl, optionId });
  },
  clear: () => {
    if (_closeTimer) {
      clearTimeout(_closeTimer);
      _closeTimer = null;
    }
    set({ anchorEl: null });
  },
  clearOptionId: () => set({ optionId: null }),
  scheduleClear: (delay = 120) => {
    if (_closeTimer) clearTimeout(_closeTimer);
    _closeTimer = setTimeout(() => {
      _closeTimer = null;
      set({ anchorEl: null });
    }, delay);
  },
  cancelClear: () => {
    if (_closeTimer) {
      clearTimeout(_closeTimer);
      _closeTimer = null;
    }
  },
}));
